import { collection, doc, getDocs } from 'firebase/firestore'
import React, { useEffect, useMemo, useState } from 'react'
import { Adddata, CreateUser, db } from '../../data'
import { useAuth, useGeneral } from '../../context'
import { useDispatch, useSelector } from 'react-redux'
import { addUserList } from '../../store/adminPanel/UserListSlices'
import { ToastError, ToastSucces } from '../tools'
import { List } from './List'
import { UserModal } from '.'
import newUserIco from '../../assets/images/agregar-contacto-green.png'
import searchIco from '../../assets/images/searchIco.png'
import { useNavigate } from 'react-router-dom'
import { GroupGeren } from './GroupGeren'

export const UserList = ({ permisos, hadleDetail, handleModalUser, subSection, setModUser, modUser }) => {
   

    const { formatDate } = useGeneral()
    const { signup, user, logout } = useAuth()
    const navigate = useNavigate()
    const userList = useSelector((state) => state.userList) || []
    const totalGeren = useSelector((state) => state.totalGeren)
    const openDetail = useSelector(state => state.openDetail)
    const [savingMod, setSavingMod] = useState(false)
    const [savingAdd, setSavingAdd] = useState(false)
    const [gn,setGn] = useState()
    const [searchTerm, setSearchTerm] = useState('')
    const [permisoFilter, setPermisoFilter] = useState('Todos')
    const [validatorFilter, setValidatorFilter] = useState('Todos')

    const permisoValue = (permiso) => (typeof permiso === 'string' ? permiso : permiso?.value || permiso?.label || '')
    const permisoLabel = (permiso) => (typeof permiso === 'string' ? permiso : permiso?.label || permiso?.value || '')
    const permisoInfo = (permiso) => (typeof permiso === 'string' ? '' : permiso?.info || permiso?.detail || '')
    const permisoOptionLabel = (permiso) => {
        const label = permisoLabel(permiso)
        const info = permisoInfo(permiso)
        return info ? `${label} (${info})` : label
    }

    useEffect(() => {
        const fetchData = async () => {
            setGn(totalGeren)
        };
        fetchData();
    }, []);
    
    const dispatch = useDispatch()
    const compareApellido = (a, b) => {
        const apellidoA = a?.Apellido || ''
        const apellidoB = b?.Apellido || ''
        if (apellidoA && apellidoB) {
            return apellidoA.localeCompare(apellidoB)
        }
        const nombreA = a?.Nombre || ''
        const nombreB = b?.Nombre || ''
        return (apellidoA || nombreA).localeCompare(apellidoB || nombreB)
    }

    const normalizeText = (value) => {
        if (!value) return ''
        return value
            .toString()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
    }

    const filteredUsers = useMemo(() => {
        const search = normalizeText(searchTerm.trim())
        return userList.filter((user) => {
            if (permisoFilter !== 'Todos' && user.Permiso !== permisoFilter) {
                return false
            }
            if (validatorFilter === 'Solo validadores' && !user.EsValidador) {
                return false
            }
            if (validatorFilter === 'Solo no validadores' && user.EsValidador) {
                return false
            }
            if (!search) return true

            const fields = [
                user.Nombre,
                user.Apellido,
                user.Mail,
                user.Permiso,
                user.EsValidador ? 'validador' : '',
                user.AreaDeVentas,
                user.Gerencia,
                user.Cuit,
                user.CUIT,
                user.UID,
                user.PID,
            ]

            return fields.some((field) => normalizeText(field).includes(search))
        })
    }, [userList, searchTerm, permisoFilter, validatorFilter])

    const submitUserModification = async (e, modUser, user) => {
        //console.log(modUser)
        e.preventDefault()
        setSavingMod(true)

        try {

            let docRef = doc(db, 'Usuarios', user.UID)
            //aca se sube
  await Adddata(docRef, modUser) 
        } catch (error) {
            ToastError('No se pudo modificar')
        } finally {
            setSavingMod(false)

            handleModalUser(false)
            ToastSucces('Usuario actualizado')
        }
    }
//console.log(totalGeren)
//al crear un usuario se cerrara la sesion
    const submitCreateUser = async (e, modUser) => {
        e.preventDefault()
   
        const findAreaDeVentas = totalGeren.find(b => b.AreaDeVentas == modUser.AreaDeVentas)
        const pidCorrecto = findAreaDeVentas?.[modUser.Permiso] || findAreaDeVentas?.Administracion || ''
        // Encuentra el PID CORRECTO Y SU AREA DE VENTAS
        const gerenciaCorrecta = (userList.find(e => e.PID === findAreaDeVentas?.Gerencia))
        // Encontrando el Nombre del gerente que le corresponde
        const gerenNombre = `${gerenciaCorrecta?.Nombre} ${gerenciaCorrecta?.Apellido}`
        

        try {
            setSavingAdd(true)
            const creden = await signup(modUser.Mail, 'Goldmund') 
            //console.log(creden.user.uid)
            //modUser.mail
            await CreateUser(
                {
                    ...modUser,
                    lastLogin: 0,
                    UID: creden.user.uid,
                    Mail: modUser.Mail,
                    AreaDeVentas:modUser.AreaDeVentas,
                    PID:pidCorrecto,
                    Id:findAreaDeVentas?.Id || '',
                    Gerencia:gerenNombre.trim() || '-',
                    Permiso:modUser.Permiso || 'Vendedor',
                    EsValidador: Boolean(modUser.EsValidador),
                    Baja: Boolean(modUser.Baja)
                    //TODO: ver de donde saco esto
                    // Gerencia: "",
                    // Id: "20",
                    // PID: "04",
                }
            )
        } catch (error) {
            // console.log(error)
            ToastError('Fallo al crear usuario')
        } finally {
            setSavingAdd(false)
        // await logout();
        // navigate("/")
        }
    }

    useEffect(() => {
        // TODO: pasar a snapshot para mejor respuesta si se piensa utilizar mucho
        const handleGetUsers = async () => {
            let list = []

           const docs = await getDocs(collection(db, "Usuarios"))

            docs.forEach((doc) => {
                // console.log(typeof doc.data().lastLogin === 'object')
                let lastlog = '0'
                if (typeof doc.data().lastLogin === 'object') {
                    lastlog = formatDate(doc.data().lastLogin)
                }

                list.push(
                    {
                        ...doc.data(),
                        lastLogin: lastlog
                    }
                )
            })
            list.sort(compareApellido)

           dispatch(addUserList(list))  
        }
        handleGetUsers()
    }, [])



    return (
        <div className='p-2 mb-3'>

            <div className='mt-2'>
                <div className='d-flex justify-content-between'>
                    <h4 className='separar my-4'>
                        <b className='text-uppercase'>Lista de usuarios</b>
                    </h4>

                    <img
                        src={newUserIco}
                        alt="NEW_USER"
                        onClick={(e) => handleModalUser(true, 'add')}
                        className='cursorPointer h-75 addUserIco'
                    />
                </div>

                <div className="adminPanelToolbar">
                    <div className="adminSearch">
                        <img src={searchIco} alt="Buscar" className="adminSearchIcon" />
                        <input
                            type="text"
                            className="form-control inputs adminSearchInput"
                            placeholder="Buscar usuario por nombre, mail o permiso"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <select
                        className="form-control inputs adminFilterSelect"
                        value={permisoFilter}
                        onChange={(e) => setPermisoFilter(e.target.value)}
                    >
                        <option value="Todos">Todos los permisos</option>
                        {permisos
                            .filter((permiso) => !['Sysadmin', 'Direccion'].includes(permisoValue(permiso)))
                            .map((permiso) => (
                            <option key={permisoValue(permiso)} value={permisoValue(permiso)}>
                                {permisoOptionLabel(permiso)}
                            </option>
                        ))}
                    </select>
                    <select
                        className="form-control inputs adminFilterSelect"
                        value={validatorFilter}
                        onChange={(e) => setValidatorFilter(e.target.value)}
                    >
                        <option value="Todos">Todos</option>
                        <option value="Solo validadores">Solo validadores</option>
                        <option value="Solo no validadores">Solo no validadores</option>
                    </select>
                    <div className="adminListMeta">
                        {filteredUsers.length} de {userList.length} usuarios
                    </div>
                </div>

                <List
                    users={filteredUsers}
                    allUsers={userList}
                    openDetail={openDetail}
                    hadleDetail={hadleDetail}
                    handleModalUser={handleModalUser}
                    permisos={permisos}
                    submitUserModification={submitUserModification}
                    savingMod={savingMod}
                    subSection={subSection}
                />

                <UserModal subSection={subSection} user={subSection === 'mod' ? modUser : {}}
                    setModUser={setModUser} handleModalUser={handleModalUser} permisos={permisos}
                    submit={subSection === 'mod' ? submitUserModification : submitCreateUser} savingMod={savingMod} saving={savingAdd}
                />
            </div>
        </div>
    )
}
